import { useCallback } from 'react';
import { useBreakpoint } from '@jutro/layout';
// import appConfig from 'app-config';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import styles from './ApplicationHeader.module.scss';
import metadata from './ApplicationHeader.metadata.json5';
import './ApplicationHeader.messages'
import { Button } from '@jutro/legacy/components';

export default function ApplicationHeader(props) {
    const { logoSrc, onSearchValueChange, onLoadValues } = props.header;
    const { breakpoint } = useBreakpoint({});

    const getLogoStyle = useCallback(()=>{
        if(breakpoint === 'desktop'){
            return "logoDesktop";
        }
        if(breakpoint === 'tablet'){
            return "logoTablet";
        }

        return "logoPhone";
    }, [breakpoint]);

    const renderTriggerFn = useCallback((toggle, ref, isShown)=> { 
        // eslint-disable-next-line react/react-in-jsx-scope
        return <Button onClick={toggle} ref={ref} aria-expanded={isShown}>
            Toggle
        </Button>
    });

    const overrides = {
        logoImage: {
            src: logoSrc,
            className: getLogoStyle()
        },
        headerNotifications1: {
            renderTrigger: renderTriggerFn
        },
        search: {
            onValueChange: onSearchValueChange,
            onLoadValues: onLoadValues
        },
        subheaderContrainer: {
            
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            renderTriggerFn: renderTriggerFn,
            onSearchValueChange: onSearchValueChange,
            onLoadValues: onLoadValues
        }
    };

    // eslint-disable-next-line react/react-in-jsx-scope
    return <MetadataContent uiProps={metadata.pageContent} overrideProps={overrides} {...resolvers} />;
};